import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '@99designs/common/components/Button';
import { Icon } from '@99designs/common/components/Icon';

class OverviewPanel extends React.Component {
    constructor(props) {
        super();

        this.handleCollapseRequested = this.handleCollapseRequested.bind(this);
        this.handleExpandRequested = this.handleExpandRequested.bind(this);

        this.state = {
            layout: 'collapsed',
        };
    }

    render() {
        const { children, summaryAmount } = this.props;
        const { layout } = this.state;

        return (
            <div className="overview-panel" data-state-layout={layout}>
                <div className="overview-panel__expand-action">
                    <Button
                        variations={['link']}
                        title="Button title"
                        onClick={this.handleExpandRequested}
                        icon={<Icon type={'up-1'} />}
                        iconAlignment="right"
                    >
                        <FormattedMessage
                            id="overview.expand_action_label"
                            values={{
                                amount: summaryAmount,
                            }}
                        />
                    </Button>
                </div>
                <div className="overview-panel__content">{children}</div>
                <div className="overview-panel__collapse-action">
                    <Button
                        variations={['link']}
                        title="Button title"
                        onClick={this.handleCollapseRequested}
                        icon={<Icon type={'down-1'} />}
                        iconAlignment="right"
                    >
                        <FormattedMessage id="overview.collapse_action_label" />
                    </Button>
                </div>
            </div>
        );
    }

    handleCollapseRequested() {
        this.setState({ layout: 'collapsed' });
    }

    handleExpandRequested() {
        this.setState({ layout: 'expanded' });
    }
}

OverviewPanel.propTypes = {
    summaryAmount: PropTypes.node,
};

OverviewPanel.defaultProps = {
    summaryAmount: null,
};

export default OverviewPanel;
